import { useTranslation } from 'react-i18next';

function TimeoutLogout() {
  const { t } = useTranslation('account');

  return (
    <main id="logout">
      <section>
        <div className="container">
          <h1 id="instructions">{t('idleTime.loggedOut')}</h1>
          <p>{t('idleTime.info')}</p>
          <p>{t('idleTime.prompt')}</p>
        </div>
      </section>
    </main>
  );
}

export default TimeoutLogout;
